
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instagram-tracking-faq",
      function () {
        return require("private-next-pages/instagram-tracking-faq/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instagram-tracking-faq"])
      });
    }
  